import React, { Component } from 'react';
import CartProduct from '../CartProduct';
import { Card } from 'react-bootstrap';
import { HiOutlinePencil, HiTrash } from "react-icons/hi";
import { BsToggleOn, BsToggleOff } from 'react-icons/bs';
import { FaRegCopy } from "react-icons/fa";

class Bag extends Component {
  
    constructor(props) {
      super(props);
      this.state = {
        errorMessage: null,
        isMouseOver: false,
        changeName: false
      };
    }

    handleMouseOver = () => {
      this.setState({ isMouseOver: true });
    };

    handleMouseOut = () => {
      this.setState({ isMouseOver: false });
    };

    editBag = (elem) => {
        let container = elem.target.closest(".title");
        let targetElem = container.children[0];
        let target = container.children[1];
        let state = target.dataset.state;
        if( state === "0" ){
            let name = targetElem.textContent.trim();
            const input = document.createElement("input");
            input.value = name;
            targetElem.replaceWith(input);
            target.setAttribute("data-state", 1);
        }
        else{
            let name = targetElem.value;
            if( name !== null && name.length > 0 ){
                const span = document.createElement("span");
                span.textContent = name;
                targetElem.replaceWith(span);
                target.setAttribute("data-state", 0);
                this.setState({errorMessage: null});
                this.props.updateCartName(name, this.props.bag.id);
            }
            else{
                // this.setState({errorMessage: "Name cannot be empty"});
                window.alert("Cart name must not be empty");
            }
        }
    }

    customToggle = (e) => {
        let target = e.target, button;
        if( target.tagName.toLowerCase() == "button" ){
            button = target;
        }
        else{
            button = target.closest("button");
        }

        if( this.props.activeBag !== this.props.bag.id ){
            this.props.selectCart(this.props.bag.id);
        }
    };

    render() {
      const { bag } = this.props;
      const classes = ['shelf-item', 'shelf-bag__item'];
      
      if (!!this.state.isMouseOver) {
        classes.push('shelf-item--mouseover');
      }

      let len = "";

      let bagItems = []
      if( bag.items.length > 0 ){
        let sortedBag = [...bag.items.sort()];
        let reveseBag = sortedBag.reverse();
          bagItems = (
            sortedBag.map(product => {
                let key = this.props.bag.id+"_"+product.id;
                return (
                    <CartProduct key={key} product={product} removeItemFromCart={this.props.removeItemFromCart} updateCartItem={this.props.updateCartItem} parent={this.props.bag.id} />
                );
            })
          )
      }

        let classnames = ["w-100"];
        let itemContainer = ["accordion-collapse", "collapse"];
        if( bag.id === this.props.activeBag ){
            classnames.push("active-bag");
            itemContainer.push("show");
        }

      return (
            <Card className={classnames.join(' ')} data-bag={bag.id}>
                <Card.Header>
                    <div className='d-flex justify-content-between'>
                        <div className="shelf-bag__name ps-3">
                            <p className='title d-flex justify-content-between mb-0'>
                                <span>{bag.name}</span>
                                <button type='button' data-state="0" onClick={elem => this.editBag(elem)} className='bg-transparent border-0 shelf-bag__icon'><HiOutlinePencil /></button>
                            </p>
                        </div>
                        <div className='shelf-bag__icons d-flex align-items-center'>
                            <div>
                                <button type='button' className="shelf-bag__icon" onClick={() => this.props.copyCart(this.props.bag.id)}><FaRegCopy /></button>
                            </div>
                            <div>
                                <button type="button" className="shelf-bag__icon" onClick={(event) => this.customToggle(event)}>{ this.props.activeBag === bag.id ? <BsToggleOn /> : <BsToggleOff />}</button>
                            </div>
                            <div>
                                <button type="button" className="shelf-bag__icon"
                                    onClick={() => this.props.removeCart(this.props.bag.id)} ><HiTrash /></button>
                            </div>
                        </div>
                    </div>
                </Card.Header>
                <div className={itemContainer.join(' ')}>
                    <Card.Body>
                        <div className='shelf-bag__my-items'>
                            {
                                bagItems
                            }
                        </div>
                    </Card.Body>
                </div>
            </Card>
      )
    }
}

export default Bag;